const esquemaCampos = {
  ticket: {valor: null, error: ''},
  descripcion: {valor: '', error: ''},
  cliente: {valor: null, error: ''},
  valorizacion: {valor: 0, error: ''},
  
};

const esquemaValidacion = {
  ticket: {
    requerido: true
  },
  descripcion: {
    requerido: true,
    validador: {
      regla: valor => {
        return valor !== '';
      },
      error: 'El campo descripción no puede estar vacio.'
    }
  },  
  cliente: {
    requerido: true,
    validador: {
      regla: valor => {
        return valor !== '';
      }
    }
  },
  valorizacion: {
    requerido: false,
    validador: {
      regla: valor => {
        return valor !== '';
      }
    }
  },  
};

module.exports = {
  esquemaCampos,
  esquemaValidacion
  //esquemaQuery,
};
